import React from 'react';

import PageComponent from 'js/components/pages/PageComponent';
import PageError from './PageError';
import AppContent from 'js/components/AppContent';

export default class NotFoundPage extends PageComponent {
  pageName = 'NotFoundPage';

  renderPage() {
    const error404 = {
      status: 404,
      error: 'Not Found',
    };

    return (
      <AppContent>
        <PageError error={error404} />
      </AppContent>
    );
  }
}
